angular.module('impactx.search').component('ixProductItemActions', {
        bindings: {
            product: '<',
            postAdd: '&',
            fullyConfigured: '<',
            vCatId: '<'
        },
        controller: 'ProductItemActionsCtrl',
        controllerAs: 'actionsCtrl',
        templateUrl: 'modules/search/templates/product-item-actions.html'
    }
);